// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__25d5U","list":"styles_list__3-mSJ"};